import HttpError from 'utils/HttpError';
import trackError from 'utils/trackError';

// Types

export type State = Error | null | undefined;

type SetErrorAction = {
  type: 'SET_ERROR';
  error: Error;
};
export type Action = SetErrorAction;

// Reducer

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last, import/no-default-export
export default function errorReducer(state: State = null, action: Action) {
  switch (action.type) {
    case 'SET_ERROR':
      return action.error;

    default:
      return state;
  }
}

// Actions

export const setError = (error: Error, track = true): SetErrorAction => {
  if (track && error instanceof HttpError && error.statusCode !== 404) {
    trackError(error);
  }

  return {
    type: 'SET_ERROR',
    error,
  };
};
